module.exports = __webpack_public_path__ + "img/2-7.d273e513.jpg";